// Core platform management
import type { PlatformAdapters } from "./types"

// Export all types
export * from "./types"

// Export utilities
export { StorageCache, CACHE_KEYS } from "./utils/storage-cache"

// Export adapter implementations
export { zaloPlatform, registerZaloPlatform } from "./impl/zalo"
export { appViewPlatform, registerAppViewPlatform } from "./impl/appview"

let currentPlatform: PlatformAdapters | undefined

export function registerPlatform(adapters: PlatformAdapters) {
  currentPlatform = adapters
  console.log(`Platform registered: ${adapters.device ? "success" : "failed"}`)
}

export function getPlatform(): PlatformAdapters {
  if (!currentPlatform) {
    console.error("Platform not registered - call registerPlatform() first")
    throw new Error("Platform not registered")
  }
  return currentPlatform
}
